export const SITE_AVATAR_RADIO_GROUP_UPLOAD_PHOTO = 'site-avatar-radio-group.upload-photo';
export const SITE_AVATAR_RADIO_GROUP_USE_NAME_INITIALS = 'site-avatar-radio-group.use-name-initials';
export const SITE_AVATAR_RADIO_GROUP_DIVIDER = 'site-avatar-radio-group.divider';
